import { makeStyles } from '@mui/styles';
import Grid from 'apollo-react/components/Grid';
import React from 'react';
import { useSelector } from 'react-redux';

import { useTranslation } from '../../custom-hooks/useTranslation';
import { useWindowDimensions } from '../../custom-hooks/useWindowDimensions';
import PreventMountMessage from '../../form-designer/components/PreventMountMessage';
import { getPreventFormMounting } from '../../selectors/AppConfigsSelectors';
import { getErrorDisplayMessages } from '../../selectors/MessagesSelectors';
import { getUITA } from '../../utils/commonUtils';
import * as domUtils from '../../utils/domUtils';
import BannerCard from '../BannerCard';

const useStyles = makeStyles({
  root: {
    paddingBottom: ({ isMobileDevice }) => (isMobileDevice ? 8 : 10),
  },
  bannerCard: {
    '& div': { color: 'white' },
  },
});

const ErrorDisplay = () => {
  const { isMobileDevice } = useWindowDimensions();
  const classes = useStyles({ isMobileDevice });
  const errors = useSelector(getErrorDisplayMessages);
  const translateString = useTranslation();
  const preventFormMounting = useSelector(getPreventFormMounting);

  return (
    <Grid className={classes.root} container spacing={1} ui-ta={getUITA('ErrorDisplay')}>
      {errors.map((error, index) => (
        <Grid
          key={error.id || `${error.instanceId}-${index}`}
          item
          xs={12}
          ui-ta={getUITA('error-container')}
        >
          <BannerCard
            className={classes.bannerCard}
            message={`${error.message}${
              error.code ? ` ${translateString('Error code')}: ${error.code}` : ''
            }`}
            variant={error.customVariant || 'error'}
            onClick={() => domUtils.handleWarningClick(error)}
            messageProps={{ 'ui-ta': getUITA('error-message') }}
          />
        </Grid>
      ))}
      {isMobileDevice && preventFormMounting && <PreventMountMessage />}
    </Grid>
  );
};

export default ErrorDisplay;
